import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { Button } from "reactstrap";
import Modal from "react-bootstrap/Modal";
import { useHistory, Link } from "react-router-dom";
import "./ComponentNotAllowed.css";

const ComponentNotAllowedNew = ({ status, modal, name, goBackUrl }) => {
  console.log("checkkkkkkkk", status, modal, name, goBackUrl);
  const history = useHistory();
  const userName = localStorage.getItem("firstName");
  const modulesName = name || "this Screen";
  const backUrl = goBackUrl ? "/#" + goBackUrl : "/#/Dashboard";

  const is404 = status == 10;

  useEffect(() => {
    setTimeout(() => {
      handleClose();
    }, 3000);

    document.body.classList.add("blurred-background");

    return () => {
      document.body.classList.remove("blurred-background");
    };
  }, []);

  const goToHome = () => {
    window.location.href = "/#/Dashboard";
    removeComponent();
  };

  const goToLogin = () => {
    window.location.href = "/#/login";
    removeComponent();
  };

  const handleClose = () => {
    window.location.href = backUrl;
    removeComponent();
  };

  const removeComponent = () => {
    const modalContainer = document.getElementById("component-not-allowed");
    if (modalContainer) {
      ReactDOM.unmountComponentAtNode(modalContainer);
      modalContainer.remove();
    }
  };

  return ReactDOM.createPortal(
    <Modal show={true} size="md" onHide={handleClose}>
      <Modal.Header
        closeButton
        className="bg-white border-bottom-0 pb-0 mx-auto"
      >
        <div className="d-flex flex-row justify-content-center my-4">
          <div className="rounded-pill shadow">
            <i 
              className={`fa ${is404 ? 'fa-exclamation-triangle' : 'fa-times'} fa-5x px-4 py-3 ${is404 ? 'text-warning' : 'text-danger'}`}
            ></i>
          </div>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="text-center">
        
         
            <>
              <h2>404 - Page Not Found</h2>
              <h5 className="mt-3">
                The page you're looking for doesn't exist or has been moved.
              </h5>
              <Button color="primary" className="mt-4" onClick={goToHome}>
                Go to Dashboard
              </Button>
            </>

           
           
         
        </div>
      </Modal.Body>
    </Modal>,
    document.body
  );
};


export const showComponentNotAllowed = (status, name, goBackUrl, modal) => {
  let modalContainer = document.createElement("div");
  modalContainer.id = "component-not-allowed";
  document.body.appendChild(modalContainer);

  ReactDOM.render(
    <ComponentNotAllowedNew
      status={status}
      name={name}
      goBackUrl={goBackUrl}
      modal={modal}
    />,
    modalContainer
  );
};

export default ComponentNotAllowedNew;